import { useQuery } from '@tanstack/react-query';
import { isBuyMarketplaceSupported } from './supported-marketplaces';
import makeQueryKey from "../../utils/make-query-key";
var getQueryKey = function getQueryKey() {
  return makeQueryKey(['buy', 'marketplaceSupported']);
};
var useIsBuyMarketplaceSupported = function useIsBuyMarketplaceSupported() {
  var _useQuery = useQuery({
      queryKey: getQueryKey(),
      queryFn: isBuyMarketplaceSupported,
      staleTime: Infinity
    }),
    _useQuery$data = _useQuery.data,
    isSupported = _useQuery$data === void 0 ? false : _useQuery$data;
  return isSupported;
};
export default useIsBuyMarketplaceSupported;